import { render } from "./SectionButton.vue?vue&type=template&id=8549bb88&scoped=true&ts=true"
import script from "./SectionButton.vue?vue&type=script&lang=ts"
export * from "./SectionButton.vue?vue&type=script&lang=ts"

import "./SectionButton.vue?vue&type=style&index=0&id=8549bb88&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8549bb88"]])

export default __exports__